import { Navigate, Route, Routes } from "react-router-dom";

import { useUserAuthenticationContext } from "@/src/contexts";
import { usePageContext } from "@/src/contexts/PageContext";
import Master from "@/src/master/Master";
import { browserStatics } from "@/src/shared/BrowserStatic";
import { BlogIndexMobile } from "@Routes/BlogLinks";

import pages from "./pages";

export default function AppRouting() {
    const { isAuthenticated } = useUserAuthenticationContext();
    const { component } = usePageContext();

    const generateBrandDetailsPaths = (routes: string[]) =>
        routes.map((brandPath, index) => (
            <Route key={index} path={brandPath} Component={pages.BrandDetails} />
        ));

    if (component && component.componentName === "GenericError") {
        return <Master />;
    }

    return (
        <Routes>
            <Route index Component={pages.Homepage} />
            {isAuthenticated && <Route path="/cashback" Component={pages.CashbackMainPage} />}
            <Route path="/app/cashback" element={<Navigate to="/cashback" />} />
            <Route path="/user/validateEmail/:emailId" Component={pages.EmailConfirmationPage} />
            <Route
                path={`${browserStatics.isMobileApp ? BlogIndexMobile : "/blog"}/:p1?/:p2?/:p3?`}
                Component={pages.Blog}
            />
            <Route path="/gazetki" Component={pages.FlyersTab} />
            <Route path="/gazetki/:brandName/:discountSeoName" Component={pages.FlyerDetails} />

            {generateBrandDetailsPaths([
                "marka/:brandName",
                "marka/:brandName/gazetka-promocyjna",
                "marka/:brandName/cashback",
            ])}

            <Route path="*" Component={Master} />
        </Routes>
    );
}
